import type React from 'react'
import Skeleton from 'react-loading-skeleton'
import * as S from './Minisearch.styles'

const FilterChipSkeleton: React.FC = () => {
  return (
    <div
      style={{
        height: '2.2rem',
        minWidth: '60px',
        maxWidth: '120px',
        width: `${Math.floor(Math.random() * 60) + 60}px`, // Random width between 60-120px
      }}
    >
      <Skeleton height="2.2rem" style={{ borderRadius: '0' }} />
    </div>
  )
}

export const SuggestionsSkeleton: React.FC = () => {
  return (
    <S.SuggestionsContainer>
      <h2>
        <Skeleton width="140px" height="2rem" />
      </h2>
      <S.VerticalList role="list">
        {Array.from({ length: 6 }).map((_, index) => (
          <FilterChipSkeleton key={index} />
        ))}
      </S.VerticalList>
    </S.SuggestionsContainer>
  )
}
